<template>
    <svg width="800px" height="800px" viewBox="-6.5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" fill="#f09a0e">

        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier"><title>menu_option [#f09a0e]</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-226.000000, -800.000000)" fill="#f09a0e">
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path
                            d="M173.5,658 C172.856,658 172.333333,657.552 172.333333,657 C172.333333,656.448 172.856,656 173.5,656 C174.144,656 174.666667,656.448 174.666667,657 C174.666667,657.552 174.144,658 173.5,658 M174.666667,654 L172.333333,654 C171.044167,654 170,654.895 170,656 L170,658 C170,659.105 171.044167,660 172.333333,660 L174.666667,660 C175.955833,660 177,659.105 177,658 L177,656 C177,654.895 175.955833,654 174.666667,654 M173.5,651 C172.856,651 172.333333,650.552 172.333333,650 C172.333333,649.448 172.856,649 173.5,649 C174.144,649 174.666667,649.448 174.666667,650 C174.666667,650.552 174.144,651 173.5,651 M174.666667,647 L172.333333,647 C171.044167,647 170,647.895 170,649 L170,651 C170,652.105 171.044167,653 172.333333,653 L174.666667,653 C175.955833,653 177,652.105 177,651 L177,649 C177,647.895 175.955833,647 174.666667,647 M173.5,644 C172.856,644 172.333333,643.552 172.333333,643 C172.333333,642.448 172.856,642 173.5,642 C174.144,642 174.666667,642.448 174.666667,643 C174.666667,643.552 174.144,644 173.5,644 M174.666667,640 L172.333333,640 C171.044167,640 170,640.895 170,642 L170,644 C170,645.105 171.044167,646 172.333333,646 L174.666667,646 C175.955833,646 177,645.105 177,644 L177,642 C177,640.895 175.955833,640 174.666667,640"
                            id="menu_option-[#f09a0e]"></path>
                    </g>
                </g>
            </g>
        </g>

    </svg>
</template>
<script>
export default {
    name: "FabMenuIcon",
};
</script>
<style scoped></style>
